import React, { useEffect, useState } from "react";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL
} from "../../../Util/axios_core_helper";
import { CommonErrorMsg, ErrorMsg, ValidateForm } from "../../../Util/common";
import { KendoMultiSelect } from "../../../Kendo/kendo_multiselect";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { KendoDatePicker } from "../../../Kendo/kendo_datepicker";
import { KendoLoader } from "../../../Kendo/kendo_loader";

const Vendor = () => {
  const [vendor, setVendor] = useState({
    VendorID: 0,
    VendorName: "",
    ClientName: "",
    EventDate: "",
    BallroomID: 0,
    CompanyName: "",
    VendorTypeId: "",
    EmailID: "",
    PhoneNumber: "",
    Facebook: "",
    Twitter: "",
    Instagram: "",
    TikTok: "",
    LinkedIn: "",
    Pinterest: "",
    YouTube: "",
    Vimeo: "",
    Flickr: "",
    CreatedBy: 0,
  });

  const [error, setError] = useState({});

  const [isToggleOn, setIsToggleOn] = useState(false);
  const [sumInput, setSumInput] = useState(""); // State for CAPTCHA (sum) input
  const [formErrors, setFormErrors] = useState({ sum: "" });
  const { selDisplayedInIds } = useSelector((state) => state.Amenities);
  //   const dispatch = useDispatch();
  const handleToggleChange = (event) => {
    setIsToggleOn(event.target.checked);
  };
  const [randomNum1, setRandomNum1] = useState(5);
  const [captchaInput, setCaptchaInput] = useState("");
  const [randomNum2, setRandomNum2] = useState(7);
  const [ballroomData, setBallroomData] = useState([]);
  const [vendorData, setVendorData] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [BreadcrumList, setBreadcrumList] = useState([]);

  const fetchBreadcrumImageData = async () => {
    try {
      const response = await corefetch(
        "Breadcrum/GetBreadcrumDetailsByCategory?CategoryCode=VENDOR"
      );
      if (response && response.length > 0) {
        console.log("fxftyxfyt:", response);
        setBreadcrumList(response);
      } else {
        setBreadcrumList([]);
        console.log("No Breadcrum found");
      }
    } catch (error) {
      console.error("Error fetching Breadcrum List:", error);
      setBreadcrumList([]);
    }
  };

  const backgroundImageStyle = BreadcrumList[0]
    ? {
        backgroundImage: `url(${ImageURL}${BreadcrumList[0].imagePath})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : {};
  const differentProblem = () => {
    const attempt = timesWrongPlural();
    let num1, num2;

    if (attempt === "1") {
      num1 = Math.floor(Math.random() * 9) + 1;
      num2 = Math.floor(Math.random() * 90) + 10;
    } else if (attempt === "2") {
      num1 = Math.floor(Math.random() * 90) + 10;
      num2 = Math.floor(Math.random() * 90) + 10;
    } else if (attempt === "3") {
      num1 = Math.floor(Math.random() * 900) + 100;
      num2 = Math.floor(Math.random() * 900) + 100;
    } else {
      num1 = Math.floor(Math.random() * 9) + 1;
      num2 = Math.floor(Math.random() * 9) + 1;
    }

    setRandomNum1(num1);
    setRandomNum2(num2);
  };
  const timesWrongPlural = () => {
    return Math.floor(Math.random() * 4) + 1;
  };
  const fetchBallroomData = async () => {
    try {
      const list = await corefetch("Facility/GetActiveBallroomData");
      if (list && list.length > 0) {
        setBallroomData(list);
      }
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchBallroomData();
    fetchBreadcrumImageData();
  }, []);

  const fetchVendorData = async () => {
    try {
      const list = await corefetch("Vendor/GetVendorTypeNames");
      if (list && list.length > 0) {
        setVendorData(list);
      }
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchVendorData();
  }, []);

  const clearForm = () => {
    setLoading(false);
    setVendor({
      VendorID: 0,
      VendorName: "",
      ClientName: "",
      EventDate: "",
      BallroomID: 0,
      CompanyName: "",
      VendorTypeId: [],
      EmailID: "",
      PhoneNumber: "",
      Facebook: "",
      Twitter: "",
      Instagram: "",
      TikTok: "",
      LinkedIn: "",
      Pinterest: "",
      YouTube: "",
      Vimeo: "",
      Flickr: "",
      CreatedBy: 0,
    });
    setIsToggleOn(false);

    const form = document.getElementById("form-culture-config");
    if (form) {
      form.reset();
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const facebookPattern = /^https:\/\/.*facebook.*$/;
    const twitterPattern = /^https:\/\/.*x.*$/;
    const instagramPattern = /^https:\/\/.*instagram.*$/;
    const tiktokPattern = /^https:\/\/.*tiktok.*$/;
    const linkedinPattern = /^https:\/\/.*linkedin.*$/;
    const youtubePattern = /^https:\/\/.*youtube.*$/;
    const vimeoPattern = /^https:\/\/.*vimeo.*$/;
    const flickrPattern = /^https:\/\/.*flickr.*$/;
    const pinterestPattern = /^https:\/\/.*pinterest.*$/;

    let err = ValidateForm(e) || {};
    let rawPhoneValue = vendor.PhoneNumber.replace(/\D/g, "");

    if (!vendor.PhoneNumber) {
      err.PhoneNumber = "Phone number is required";
    } else if (rawPhoneValue.length !== 10) {
      err.PhoneNumber = "Phone number must be 10 digits";
    }

    if (isToggleOn) {
      // if (!vendor.EventDate) {
      //   err.EventDate = true;
      // }
      if (!vendor.BallroomID || vendor.BallroomID === "0") {
        err.BallroomID = true;
      }
    }
    if (!vendor.EmailID) {
      err.EmailID = "Email ID is required";
    } else if (!emailPattern.test(vendor.EmailID)) {
      err.ValidEmail = "Invalid email address";
    }

    if (
      !vendor.VendorTypeId ||
      vendor.VendorTypeId.length === 0 ||
      vendor.VendorTypeId.some((id) => id.trim() === "")
    ) {
      err.VendorTypeId = "Vendor Type is required";
    }
    if (vendor.Facebook && !facebookPattern.test(vendor.Facebook)) {
      err.Facebook = "Invalid Facebook URL";
    }
    if (vendor.Twitter && !twitterPattern.test(vendor.Twitter)) {
      err.Twitter = "Invalid Twitter URL";
    }
    if (vendor.Instagram && !instagramPattern.test(vendor.Instagram)) {
      err.Instagram = "Invalid Instagram URL";
    }
    if (vendor.TikTok && !tiktokPattern.test(vendor.TikTok)) {
      err.TikTok = "Invalid TikTok URL";
    }

    if (vendor.LinkedIn && !linkedinPattern.test(vendor.LinkedIn)) {
      err.LinkedIn = "Invalid LinkedIn URL";
    }

    if (vendor.YouTube && !youtubePattern.test(vendor.YouTube)) {
      err.YouTube = "Invalid YouTube URL";
    }
    if (vendor.Vimeo && !vimeoPattern.test(vendor.Vimeo)) {
      err.Vimeo = "Invalid Vimeo URL";
    }

    if (vendor.Flickr && !flickrPattern.test(vendor.Flickr)) {
      err.Flickr = "Invalid Flickr URL";
    }

    if (vendor.Pinterest && !pinterestPattern.test(vendor.Pinterest)) {
      err.Pinterest = "Invalid Pinterest URL";
    }

    if (!captchaInput.trim()) {
      err.Captcha = "Captcha is required"; // If the captcha is empty, show "Captcha is required"
      setError({ ...err });
    } else if (parseInt(captchaInput, 10) !== randomNum1 + randomNum2) {
      err.Captcha = "Invalid Captcha! Please try again."; // Show "Invalid Captcha" if the input is incorrect
      setError({ ...err }); // Update error state
      differentProblem(); // Refresh the captcha
      setCaptchaInput(""); // Reset the captcha input
    } else {
      // If captcha is valid, remove the captcha error
      setError((prev) => {
        const { Captcha, ...rest } = prev; // Remove Captcha error from the state
        return rest;
      });
    }

    if (Object.keys(err).length > 0) {
      setError(err);
    } else {
      setLoading(true);
      // If there are no errors, proceed to form submission
      const formData = new FormData();

      formData.append("vendorID", vendor.VendorID);
      formData.append("vendorName", vendor.VendorName);
      formData.append("clientName", vendor.ClientName);
      formData.append(
        "eventDate",
        vendor.EventDate
          ? new Date(vendor.EventDate).toISOString()
          : new Date().toISOString()
      );
      // formData.append("eventDate", vendor.EventDate);
      formData.append("ballroomID", vendor.BallroomID);
      formData.append("companyName", vendor.CompanyName);
      if (
        Array.isArray(vendor.VendorTypeId) &&
        vendor.VendorTypeId.filter((item) => item !== "").length > 0
      ) {
        formData.append("VendorTypeID", vendor.VendorTypeId.join(","));
      } else {
        formData.append("VendorTypeID", "");
      }
      //   formData.append("vendorTypeId", vendor.VendorTypeId);
      formData.append("emailID", vendor.EmailID);
      formData.append("phoneNumber", vendor.PhoneNumber);
      formData.append("facebook", vendor.Facebook);
      formData.append("twitter", vendor.Twitter);
      formData.append("instagram", vendor.Instagram);
      formData.append("tikTok", vendor.TikTok);
      formData.append("linkedIn", vendor.LinkedIn);
      formData.append("pinterest", vendor.Pinterest);
      formData.append("youTube", vendor.YouTube);
      formData.append("vimeo", vendor.Vimeo);
      formData.append("flickr", vendor.Flickr);
      formData.append("createdBy", 0);

      try {
        await corepost(
          "Vendor/InsertUpdateVendorRegister",
          formData,
          true,
          true,
          false,
          false,
          "Submitted Successfully"
        );
        clearForm();
        setCaptchaInput("");
        //toast.success("Saved Succesfully");
      } catch (error) {
        console.error("Error saving vendor data:", error);
        alert("Error saving vendor data.");
      }
    }
  };

  const onValidation = (name, val) => {
    setError((prevErr) => ({
      ...prevErr,
      [name]:
        !val ||
        (typeof val === "string" && val.trim() === "") ||
        (name === "BallroomID" && (val === "0" || val === 0 || val === "")) ||
        (name === "VendorTypeId" &&
          (!val || val.length === 0 || val.some((id) => id.trim() === ""))) ||
        (name === "EventDate" &&
          (val === "" || val === null || val === undefined)),
    }));
  };

  const handleDropdownChangeVendor = (e) => {
    console.log("Selected Vendor Types:", e);
    const selectedValues = Array.isArray(e) ? e : [e];

    setVendor((prevVendor) => ({
      ...prevVendor,
      VendorTypeId: selectedValues,
    }));

    // Update the error state dynamically
    setError((prevError) => ({
      ...prevError,
      VendorTypeId: selectedValues.length === 0, // Show error if no values are selected
    }));
  };

  const handleDateChange = (e) => {
    const selectedDate = e ? e : null;
    if (selectedDate == null) {
      setVendor((prev) => ({
        ...prev,
        EventDate: null,
      }));
      setError({ ...error, EventDate: true });
    } else {
      setVendor((prev) => ({
        ...prev,
        EventDate: selectedDate,
      }));
      setError({ ...error, EventDate: false });
    }
  };
  return (
    <>
      <section className="wpo-page-title vendor" style={backgroundImageStyle}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <div className="wpo-breadcumb-wrap">
                <h2>Vendor</h2>
                <ol className="wpo-breadcumb-wrap">
                  <li>
                    <a href="index.html">Home</a>
                  </li>
                  <li>Vendor</li>
                </ol>
              </div>
            </div>
          </div>{" "}
        </div>{" "}
      </section>

      <section className="multi_step_form">
        <form
          id="form-culture-config"
          className="styled-form"
          onSubmit={handleSubmit}
        >
          <div className="form-section custom row align-items-center">
            {/* Label Section */}
            <div className="col-md-7 col-12 text-md-end text-center mb-2 mb-md-0">
              <label htmlFor="meridian-toggle" className="toggle">
                Have you done an event on Meridian?
              </label>
            </div>

            {/* Toggle Section */}
            <div className="col-md-5 col-12 d-flex justify-content-center justify-content-md-start">
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  id="meridian-toggle"
                  name="meridianEvent"
                  onChange={handleToggleChange}
                  checked={isToggleOn}
                />
                <label htmlFor="meridian-toggle" className="toggle-label" />
              </div>
            </div>
          </div>

          {isToggleOn && (
            <div className="form-section margin">
              <div className="form-row">
                <div className="col-md-4 col-12 mb-3">
                  <label htmlFor="clientName">
                    Client Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="control form-control"
                    placeholder="Enter Client Name"
                    name="ClientName"
                    value={vendor.ClientName || ""}
                    data-required="true"
                    onChange={(e) => {
                      setVendor((prev) => ({
                        ...prev,
                        ClientName: e.target.value,
                      }));
                      onValidation("ClientName", e.target.value);
                    }}
                  />
                  <CommonErrorMsg
                    text="Client Name is required"
                    IsError={error.ClientName}
                  />
                </div>
                <div className="col-md-4 col-12 mb-3">
                  <div className="input-block mb-3">
                    <label className="form-label">Event Date</label>
                    <KendoDatePicker
                      name="EventDate"
                      value={vendor.EventDate}
                      placeholder={"Select Date"}
                      // required={true}
                      format={"MM/dd/yyyy"}
                      onChange={handleDateChange}
                      style={{
                        borderBottom:
                          "1px solid rgba(32, 35, 66, 0.25) !important",
                      }}
                    />
                    {/* <CommonErrorMsg
                                        text="Event Date is required"
                                        IsError={error.eventDate}
                                      /> */}
                    {/* <input
                                        type="date"
                                        name="eventDate"
                                        className="form-control"
                                        value={requestedVendor.eventDate}
                                        onChange={(e) =>
                                          setRequestedVendor({
                                            ...requestedVendor,
                                            eventDate: e.target.value,
                                          })
                                        }
                                      /> */}
                  </div>
                </div>
                {/* <div className="col-md-4">
                  <label htmlFor="eventDate">
                    Event Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    className="control form-control"
                    value={
                      vendor.EventDate
                        ? new Date(vendor.EventDate).toISOString().split("T")[0]
                        : ""
                    }
                    onChange={(e) => {
                      setVendor((prev) => ({
                        ...prev,
                        EventDate: e.target.value, // Save the date in YYYY-MM-DD format
                      }));
                      onValidation("EventDate", e.target.value); // Trigger validation
                    }}
                  />
                  <CommonErrorMsg
                    text="Event Date is required"
                    IsError={error.EventDate}
                  />
                </div> */}

                <div className="col-md-4 col-12 mb-3">
                  <label htmlFor="vendorType">
                    Ballroom <span className="text-danger">*</span>
                  </label>
                  <select
                    id="vendorType"
                    className="control form-control"
                    name="BallroomID"
                    value={vendor.BallroomID}
                    onChange={(e) => {
                      const value = parseInt(e.target.value, 10);
                      if (vendor) {
                        setVendor((prev) => ({
                          ...prev,
                          BallroomID: value,
                        }));
                        onValidation("BallroomID", value);
                      }
                    }}
                  >
                    <option value={0} disabled>
                      Select Ballroom
                    </option>
                    {ballroomData.map((ballroom) => (
                      <option
                        key={ballroom.facilityID}
                        value={ballroom.facilityID}
                      >
                        {ballroom.facilityName}
                      </option>
                    ))}
                  </select>
                  <CommonErrorMsg
                    text="Ballroom is required"
                    IsError={error.BallroomID}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="form-section vendor-details-card margin">
            <div className="form-row">
              <div className="col-md-4 col-12 mb-3">
                <label htmlFor="vendorName">
                  Vendor Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="control form-control"
                  placeholder="Enter Vendor Name"
                  name="VendorName"
                  value={vendor.VendorName || ""}
                  data-required="true"
                  onChange={(e) => {
                    setVendor((prev) => ({
                      ...prev,
                      VendorName: e.target.value,
                    }));
                    onValidation("VendorName", e.target.value);
                  }}
                />
                <CommonErrorMsg
                  text="Vendor Name is required"
                  IsError={error.VendorName}
                />
              </div>
              <div className="col-md-4 col-12 mb-3">
                <label htmlFor="companyName">
                  Company Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="control form-control"
                  placeholder="Enter Company Name"
                  name="CompanyName"
                  value={vendor.CompanyName || ""}
                  data-required="true"
                  onChange={(e) => {
                    setVendor((prev) => ({
                      ...prev,
                      CompanyName: e.target.value,
                    }));
                    onValidation("CompanyName", e.target.value);
                  }}
                />
                <CommonErrorMsg
                  text="Company Name is required"
                  IsError={error.CompanyName}
                />
              </div>
              <div className="col-md-4 col-12 mb-3">
                <div className="input-block">
                  <label className="form-label">
                    Vendor Type <span className="text-danger">*</span>
                  </label>
                  <KendoMultiSelect
                    name="vendorTypeId"
                    url={CorebaseURL + "Vendor/GetVendorTypeNames"}
                    placeholder={"Select Vendor Type..."}
                    dataTextField="vendorTypeName"
                    dataValueField="vendorTypeId"
                    // value={vendor.VendorTypeId}
                    value={selDisplayedInIds}
                    required={true}
                    onValidate={onValidation}
                    onChange={handleDropdownChangeVendor}
                    tagMode="multiple"
                  />
                </div>
                <CommonErrorMsg
                  text="Vendor Type is required"
                  IsError={error.VendorTypeId}
                />
              </div>
            </div>
            <div className="form-row">
              <div className="col-md-4 col-12 mb-3">
                <label htmlFor="email">
                  Email ID <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  className="control form-control"
                  placeholder="Enter EmailID"
                  name="EmailID"
                  value={vendor.EmailID || ""}
                  data-required="true"
                  onChange={(e) => {
                    setVendor((prev) => ({
                      ...prev,
                      EmailID: e.target.value,
                    }));
                    onValidation("EmailID", e.target.value);
                    // Email validation
                    const emailPattern =
                      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

                    // Check if the email is valid or not
                    if (
                      !emailPattern.test(e.target.value) &&
                      e.target.value !== ""
                    ) {
                      setError((prevError) => ({
                        ...prevError,
                        ValidEmail: true,
                      }));
                    } else {
                      setError((prevError) => ({
                        ...prevError,
                        ValidEmail: false,
                      }));
                    }
                  }}
                />
                {error.ValidEmail && (
                  <ErrorMsg text="Please provide a valid email address" />
                )}
                <CommonErrorMsg
                  text="Email ID is required"
                  IsError={error.EmailID}
                />
              </div>
              <div className="col-md-4 col-12 mb-3">
                <label htmlFor="phoneNo">
                  Phone No <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="control form-control"
                  placeholder="Enter PhoneNumber"
                  name="PhoneNumber"
                  value={vendor.PhoneNumber || ""}
                  data-required="true"
                  onChange={(e) => {
                    // Clear previous error message
                    setError((prevError) => ({
                      ...prevError,
                      PhoneNumber: false, // Clear the 'PhoneNumber' required error
                      invalidNo: false, // Clear the 'invalidNo' error state
                    }));

                    let rawValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters

                    // Limit the number of digits to 10
                    if (rawValue.length > 10)
                      rawValue = rawValue.substring(0, 10);

                    // Format the phone number as (XXX) XXX-XXXX
                    let formattedValue = "";
                    if (rawValue.length > 3) {
                      formattedValue = `(${rawValue.substring(
                        0,
                        3
                      )}) ${rawValue.substring(3, 6)}${
                        rawValue.length > 6 ? "-" + rawValue.substring(6) : ""
                      }`;
                    } else if (rawValue.length > 0) {
                      formattedValue = `(${rawValue}`;
                    }

                    // Update the phone number in the vendor state
                    setVendor((prev) => ({
                      ...prev,
                      PhoneNumber: formattedValue,
                    }));

                    if (rawValue.length === 0) {
                      setError((prevError) => ({
                        ...prevError,
                        PhoneNumber: true, // Set error for empty phone number
                        invalidNo: false, // Clear the invalid number error
                      }));
                    } else if (rawValue.length < 10) {
                      setError((prevError) => ({
                        ...prevError,
                        invalidNo: true, // Set error for invalid number
                        PhoneNumber: false, // Clear the required error
                      }));
                    } else {
                      // Clear all errors if the phone number is valid
                      setError((prevError) => ({
                        ...prevError,
                        PhoneNumber: false,
                        invalidNo: false,
                      }));
                    }

                    onValidation("PhoneNumber", formattedValue);
                  }}
                />
                {error.invalidNo && (
                  <CommonErrorMsg
                    text="Phone number must be 10 digits"
                    IsError={true}
                  />
                )}
                <CommonErrorMsg
                  text="Phone Number is required"
                  IsError={error.PhoneNumber}
                />
              </div>
            </div>
          </div>
          <h3
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "25px",
            }}
          >
            Social Media Link Details
          </h3>
          <div className="form-section vendor-details-card margin">
            <div className="form-row">
              <div className="col-md-4 col-12 mb-3">
                <label htmlFor="facebook">Facebook</label>
                <input
                  type="text"
                  className="control form-control"
                  placeholder="Enter Facebook URL"
                  name="Facebook"
                  value={vendor.Facebook || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    const facebookRegex = /^https:\/\/.*facebook.*$/;

                    setVendor((prev) => ({
                      ...prev,
                      Facebook: value,
                    }));
                    setError((prev) => ({
                      ...prev,
                      Facebook: value && !facebookRegex.test(value),
                    }));
                  }}
                />
                {error.Facebook && (
                  <CommonErrorMsg
                    text="Please enter a valid Facebook URL"
                    IsError={error.Facebook}
                  />
                )}
              </div>
              <div className="col-md-4 col-12 mb-3">
                <label htmlFor="twitter">X(Twitter)</label>
                <input
                  type="text"
                  className="control form-control"
                  placeholder="Enter X(Twitter) URL"
                  name="Twitter"
                  value={vendor.Twitter || ""}
                  onChange={(e) => {
                    const twitterPattern = /^https:\/\/.*x.*$/;
                    const value = e.target.value;
                    setVendor((prev) => ({
                      ...prev,
                      Twitter: value,
                    }));
                    setError((prevError) => ({
                      ...prevError,
                      Twitter:
                        value && !twitterPattern.test(value)
                          ? "Please enter a valid X(Twitter) URL"
                          : "",
                    }));
                  }}
                />
                {error.Twitter && (
                  <CommonErrorMsg
                    text="Please enter a valid X(Twitter) URL"
                    IsError={error.Twitter}
                  />
                )}
              </div>

              <div className="col-md-4 col-12 mb-3">
                <label htmlFor="instagram">Instagram</label>
                <input
                  type="text"
                  className="control form-control"
                  placeholder="Enter Instagram URL"
                  name="Instagram"
                  value={vendor.Instagram || ""}
                  onChange={(e) => {
                    const instagramPattern = /^https:\/\/.*instagram.*$/;
                    const value = e.target.value;
                    setVendor((prev) => ({
                      ...prev,
                      Instagram: value,
                    }));
                    setError((prevError) => ({
                      ...prevError,
                      Instagram:
                        value && !instagramPattern.test(value)
                          ? "Please enter a valid Instagram URL"
                          : "",
                    }));
                  }}
                />
                {error.Instagram && (
                  <CommonErrorMsg
                    text="Please enter a valid Instagram URL"
                    IsError={error.Instagram}
                  />
                )}
              </div>
            </div>
            {/* Social Media Links */}
            {/* <h4 class="mt-4">Social Media</h4> */}
            <div className="form-row">
              <div className="col-md-4 col-12 mb-3">
                <label htmlFor="tiktok">TikTok</label>
                <input
                  type="text"
                  className="control form-control"
                  placeholder="Enter TikTok URL"
                  name="TikTok"
                  value={vendor.TikTok || ""}
                  onChange={(e) => {
                    const tiktokPattern = /^https:\/\/.*tiktok.*$/;
                    const value = e.target.value;
                    setVendor((prev) => ({
                      ...prev,
                      TikTok: value,
                    }));
                    setError((prevError) => ({
                      ...prevError,
                      TikTok:
                        value && !tiktokPattern.test(value)
                          ? "Please enter a valid TikTok URL"
                          : "",
                    }));
                  }}
                />
                {error.TikTok && (
                  <CommonErrorMsg
                    text="Please enter a valid TikTok URL"
                    IsError={error.TikTok}
                  />
                )}
              </div>

              <div className="col-md-4 col-12 mb-3">
                <label htmlFor="linkedin">LinkedIn</label>
                <input
                  type="text"
                  className="control form-control"
                  placeholder="Enter LinkedIn URL"
                  name="LinkedIn"
                  value={vendor.LinkedIn || ""}
                  onChange={(e) => {
                    const linkedinPattern = /^https:\/\/.*linkedin.*$/;

                    const value = e.target.value;
                    setVendor((prev) => ({
                      ...prev,
                      LinkedIn: value,
                    }));
                    setError((prevError) => ({
                      ...prevError,
                      LinkedIn:
                        value && !linkedinPattern.test(value)
                          ? "Please enter a valid LinkedIn URL"
                          : "",
                    }));
                  }}
                />
                {error.LinkedIn && (
                  <CommonErrorMsg
                    text="Please enter a valid LinkedIn URL"
                    IsError={error.LinkedIn}
                  />
                )}
              </div>

              <div className="col-md-4 col-12 mb-3">
                <label htmlFor="youtube">YouTube</label>
                <input
                  type="text"
                  className="control form-control"
                  placeholder="Enter YouTube URL"
                  name="YouTube"
                  value={vendor.YouTube || ""}
                  onChange={(e) => {
                    const youtubePattern = /^https:\/\/.*youtube.*$/;

                    const value = e.target.value;
                    setVendor((prev) => ({
                      ...prev,
                      YouTube: value,
                    }));
                    setError((prevError) => ({
                      ...prevError,
                      YouTube:
                        value && !youtubePattern.test(value)
                          ? "Please enter a valid YouTube URL"
                          : "",
                    }));
                  }}
                />
                {error.YouTube && (
                  <CommonErrorMsg
                    text="Please enter a valid YouTube URL"
                    IsError={error.YouTube}
                  />
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="col-md-4 col-12 mb-3">
                <label htmlFor="vimeo">Vimeo</label>
                <input
                  type="text"
                  className="control form-control"
                  placeholder="Enter Vimeo URL"
                  name="Vimeo"
                  value={vendor.Vimeo || ""}
                  onChange={(e) => {
                    const vimeoPattern = /^https:\/\/.*vimeo.*$/;
                    const value = e.target.value;
                    setVendor((prev) => ({
                      ...prev,
                      Vimeo: value,
                    }));
                    setError((prevError) => ({
                      ...prevError,
                      Vimeo:
                        value && !vimeoPattern.test(value)
                          ? "Please enter a valid Vimeo URL"
                          : "",
                    }));
                  }}
                />
                {error.Vimeo && (
                  <CommonErrorMsg
                    text="Please enter a valid Vimeo URL"
                    IsError={error.Vimeo}
                  />
                )}
              </div>

              <div className="col-md-4 col-12 mb-3">
                <label htmlFor="flickr">Flickr</label>
                <input
                  type="text"
                  className="control form-control"
                  placeholder="Enter Flickr URL"
                  name="Flickr"
                  value={vendor.Flickr || ""}
                  onChange={(e) => {
                    const flickrPattern = /^https:\/\/.*flickr.*$/;
                    const value = e.target.value;
                    setVendor((prev) => ({
                      ...prev,
                      Flickr: value,
                    }));
                    setError((prevError) => ({
                      ...prevError,
                      Flickr:
                        value && !flickrPattern.test(value)
                          ? "Please enter a valid Flickr URL"
                          : "",
                    }));
                  }}
                />
                {error.Flickr && (
                  <CommonErrorMsg
                    text="Please enter a valid Flickr URL"
                    IsError={error.Flickr}
                  />
                )}
              </div>

              <div className="col-md-4 col-12 mb-3">
                <label htmlFor="pinterest">Pinterest</label>
                <input
                  type="text"
                  className="control form-control"
                  placeholder="Enter Pinterest URL"
                  name="Pinterest"
                  value={vendor.Pinterest || ""}
                  onChange={(e) => {
                    const pinterestPattern = /^https:\/\/.*pinterest.*$/;
                    const value = e.target.value;
                    setVendor((prev) => ({
                      ...prev,
                      Pinterest: value,
                    }));
                    setError((prevError) => ({
                      ...prevError,
                      Pinterest:
                        value && !pinterestPattern.test(value)
                          ? "Please enter a valid Pinterest URL"
                          : "",
                    }));
                  }}
                />
                {error.Pinterest && (
                  <CommonErrorMsg
                    text="Please enter a valid Pinterest URL"
                    IsError={error.Pinterest}
                  />
                )}
              </div>
            </div>

            <div className="form-row">
              <div className="col-md-4 col-12 mb-3"></div>
              <div className="col-md-4 col-12 mb-3">
                <label htmlFor="sum">
                  What is the sum of: <span className="text-danger">*</span>
                </label>
                <div className="row">
                  <div className="col-4">
                    <label style={{ marginTop: "11px" }}>
                      <span className="number">{randomNum1}</span>
                      <span className="operator">&nbsp;+&nbsp;</span>
                      <span className="number">{randomNum2}</span>
                      <span className="equals">&nbsp;=&nbsp;</span>
                    </label>
                  </div>
                  <div className="col-6">
                    <input
                      type="text"
                      className="control form-control "
                      autoComplete="off"
                      placeholder="Enter a Sum*"
                      value={captchaInput}
                      onChange={(e) => {
                        // Allow only numbers
                        const numericValue = e.target.value.replace(/\D/g, ""); // Remove any non-digit characters
                        setCaptchaInput(numericValue); // Update the captcha input with numeric value only
                        setError((prevError) => ({
                          ...prevError,
                          Captcha: false, // Reset the Captcha error message
                        }));
                      }}
                    />
                    <CommonErrorMsg
                      text={error.Captcha} // This will show the error message (either required or invalid captcha)
                      IsError={error.Captcha !== undefined} // Show the error if Captcha is present in the error state
                    />
                  </div>
                  <div className="col-2">
                    <span onClick={differentProblem}>
                      <i className="fa fa-refresh" />
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-4"></div>
            </div>

            <div className="form-row">
              <div className="custom-button">
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <button className="theme-btn"> Submit</button>
                )}
              </div>
            </div>
          </div>
        </form>
      </section>
    </>
  );
};

export default Vendor;
